import { Icon, Label, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { defaultDateFormatJustDate } from 'Dates';

const formatExpiryDate = (date: string | undefined | null): string | null => {
  if (!date) return null;
  return moment(date).format(defaultDateFormatJustDate);
};

const isExpired = (date: string | undefined | null): boolean => {
  if (!date) return true;
  return moment(date).isBefore(moment());
};

export const renderPersonSuggestionAddition = (obj: any, t: any) => {
  if (!obj.isMissingCompetencies) return null;

  const awarenessDate = formatExpiryDate(obj.awarenessExpiryDate);
  const handlingDate = formatExpiryDate(obj.handlingExpiryDate);
  const awarenessExpired = isExpired(obj.awarenessExpiryDate);
  const handlingExpired = isExpired(obj.handlingExpiryDate);

  return (
    <div className="personSuggestionExpired">
      <Icon name="warning sign" color="orange" size="small" />
      <span className="expiredTrainingText">
        {t('message.person.missing.competencies')}
      </span>
      {awarenessExpired && awarenessDate && (
        <Label size="mini" color="red" basic>
          Awareness: {awarenessDate}
        </Label>
      )}
      {handlingExpired && handlingDate && (
        <Label size="mini" color="red" basic>
          Handling: {handlingDate}
        </Label>
      )}
    </div>
  );
};

/**
 * Compact two-icon variant for autocomplete suggestions: a red warning icon
 * when the person is not currently at CERN, an orange one when their required
 * training is missing or expired. No verbose text or date labels — hover the
 * icon for the explanation. Returns null if neither warning applies.
 */
export const renderPersonSuggestionWarningsCompact = (obj: any, t: any) => {
  const notAtCern = obj?.atCern === 'N';
  const missingCompetencies = !!obj?.isMissingCompetencies;
  if (!notAtCern && !missingCompetencies) return null;
  return (
    <span className="personSuggestionWarningsCompact">
      {notAtCern && (
        <Popup
          trigger={<Icon name="warning sign" className="warningIconNotAtCern" />}
          on={['hover']}
          size="mini"
          content={t('message.person.not.present.at.cern')}
        />
      )}
      {missingCompetencies && (
        <Popup
          trigger={<Icon name="warning sign" className="warningIconExpiredCompetency" />}
          on={['hover']}
          size="mini"
          content={t('message.person.missing.competencies')}
        />
      )}
    </span>
  );
};
